import { io } from "socket.io-client";
import {
  websocketConnected,
  websocketDisconnected,
  websocketError,
  websocketMessageReceived,
  setRooms,
} from "../slices/websocket";

let socket;

const websocketMiddleware = (store) => (next) => (action) => {
  if (action.type === "websocket/connect") {
    if (socket) {
      socket.close();
    }

    // Connect to Socket.IO server
    // action.payload should be the base URL (e.g. "http://localhost:3000")
    socket = io(action.payload, {
      transports: ["websocket"],
      // withCredentials: true, // Uncomment if you need to send cookies/session
    });

    socket.on("connect", () => {
      store.dispatch(websocketConnected());

      // Authenticate the user after connection
      // Get user data from sessionStorage or Redux store
      const token = sessionStorage.getItem("token");
      const nome = sessionStorage.getItem("nome");
      const roomsName = sessionStorage.getItem("roomsName");
      const storedUserId = sessionStorage.getItem("uid");

      // Determine userId: prefer explicit stored value, fall back to roomsName first element
      let userId = storedUserId || null;
      if (!userId && roomsName) {
        userId = roomsName.split(",")[0];
      }

      if (token && userId) {
        try {
          // Send authentication to server with roomsName (server accepts both formats)
          socket.emit("authenticate", {
            userId,
            roomsName,
          });
          console.log(
            `Authenticating socket for user: ${userId} -- ${nome} with rooms:`,
            roomsName,
          );
        } catch (error) {
          console.error(
            "Error parsing user data for socket authentication:",
            error,
          );
        }
      }
    });

    socket.on("disconnect", () => {
      store.dispatch(websocketDisconnected());
    });

    socket.on("connect_error", (error) => {
      store.dispatch(websocketError(error.message));
    });

    // Listen for authentication confirmation
    socket.on("authenticated", (data) => {
      if (data.success) {
        console.log("Socket authenticated successfully:", data.message);

        // Handle rooms that come from the server (e.g., user groups, departments)
        // If the server doesn't return rooms yet, we use example rooms
        const userRooms = data.roomsName;
        store.dispatch(setRooms(userRooms));
        console.log("Rooms joined:", userRooms);
      } else {
        console.error("Socket authentication failed:", data.message);
      }
    });

    // Listen for "avvisi:new" event specifically
    socket.on("avvisi:new", (payload) => {
      console.log("Received 'avvisi:new' event with payload:", payload);
      // Use "payload" as variable name to avoid confusion with internal "data" property
      if (payload && payload.data) {
        store.dispatch(
          websocketMessageReceived({
            type: "avvisi:new",
            data: payload.data,
          }),
        );

        // Fetch notifications from the database to refresh totals and list
        const { fetchNotifications } = require("../slices/notifications");
        store.dispatch(fetchNotifications());

        // Show snackbar for the incoming notification
        const { showSnackbar } = require("../slices/snackbar");
        store.dispatch(
          showSnackbar({
            message: `Nuova comunicazione: ${
              payload.data.titolo || payload.data.Titolo || "Ricevuto"
            }`,
            severity: payload.data.idTipologia == 2 ? "warning" : "info",
          }),
        );
      }
    });

    socket.on("issue:new", (payload) => {
      console.log("Received 'issue:new' event with payload:", payload);
      // Use "payload" as variable name to avoid confusion with internal "data" property
      if (payload && payload.data) {
        store.dispatch(
          websocketMessageReceived({
            type: "issue:new",
            data: payload.data,
          }),
        );

        // Refresh ticket stats after an issue notification for the recipient
        const {
          ticketService,
        } = require("../../pages/pages/supporthub/services/ticketService");
        ticketService
          .getStats(5, 1, {}, null)
          .then((statsResponse) => {
            console.log(
              "Issue stats refreshed after issue:new:",
              statsResponse,
            );
          })
          .catch((error) => {
            console.error(
              "Failed to refresh issue stats after issue:new:",
              error,
            );
          });

        // Show snackbar for the incoming notification
        const { showSnackbar } = require("../slices/snackbar");
        store.dispatch(
          showSnackbar({
            message: `Nuova comunicazione: ${
              payload.data.titolo || payload.data.Titolo || "Ricevuto"
            }`,
            /*  severity: payload.data.idTipologia == 2 ? "warning" : "info", */
          }),
        );
      }
    });

    // Listen for generic messages if used
    socket.on("message", (data) => {
      store.dispatch(websocketMessageReceived(data));
    });
  }

  if (action.type === "websocket/send") {
    if (socket) {
      // Assuming payload has { type, data } or similar if using generic emit
      // For specific events, you might need to adjust this.
      // Example: store.dispatch({ type: 'websocket/send', payload: { event: 'chat', data: 'hello' } })
      if (action.payload.event) {
        socket.emit(action.payload.event, action.payload.data);
      } else {
        socket.emit("message", action.payload);
      }
    }
  }

  if (action.type === "websocket/disconnect") {
    if (socket) {
      socket.disconnect();
    }
  }

  return next(action);
};

export default websocketMiddleware;
